import Container from '@ui/container/container';
import { PropsWithChildren } from 'react';

const MainContentWrapper = ({ children }: PropsWithChildren<unknown>) => {
  return (
    <Container
      data-component="MainContentWrapper"
      maxWidth="calc(var(--main-content-max-width) + calc(var(--main-content-horizontal-padding) * 2))"
      margin="32px auto"
    >
      <>{children}</>
    </Container>
  );
};

export default MainContentWrapper;
